import { Component, computed, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DurationPipe } from 'src/app/pipes/duration.pipe';
import { SaturedChipComponent, VerySaturedChipComponent } from "src/app/fitur-26/layout/chips";
import { Point } from 'src/app/pages/custom-route/interfaces/custom-route.interface';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    TranslateModule,
    DurationPipe,
    SaturedChipComponent,
    VerySaturedChipComponent
],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public indexCard: InputSignal<number> = input.required<number>();
  public point: InputSignal<Point> = input.required<Point>();
  public isDuration15Minutes: InputSignal<boolean> = input.required<boolean>();
  
  // Computed properties
  protected isSaturatedPoint = computed(() => {
    const relatedItems = this.point().relatedsItems;
    if (!relatedItems || relatedItems.length === 0) return false;
    
    return !this.point().categoryList.some(category => category.id === 10);
  })
  
  protected isVerySaturatedPoint = computed(() => {
    const relatedItems = this.point().relatedsItems;
    if (!relatedItems || relatedItems.length === 0) return false;
    
    return this.point().categoryList.some(category => category.id === 10);
  })
}
